const accessoriesNavItems = [
  {
    route: 'all-moo-products',
    id: 'all_moo_products',
  },
  {
    route: 'notebook',
    id: 'notebook',
  },
  {
    route: 'perpetual-planner',
    id: 'perpetual_planner',
  },
  {
    route: 'envelope',
    id: 'envelope',
  },
  {
    route: 'business-card-holder',
    id: 'business_card_holder',
  },
  {
    route: 'drinkware',
    id: 'drinkware',
  },
  {
    route: 'other',
    id: 'other',
  },
];

export const getIdFromRoute = (route) => {
  return accessoriesNavItems.find((item) => item.route === route).id;
};

export const getRouteFromId = (id) => {
  return accessoriesNavItems.find((item) => item.id === id).route;
};

export default accessoriesNavItems;
